import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimAutomationElementsView extends IModelBase {
  ClaimExportId: number
  Raw837FileId: number
  ClaimId: number
  ClaimStringId: string
}

@Injectable()
export class ClaimAutomationElementsViewODataService extends ODataService<IClaimAutomationElementsView> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimAutomationElementsView'
  }
}
